/* global MicroModal */
export default class CompanyModal {
  constructor(el) {
    this.el = el;
    this.initialize();
  }

  initialize() {
    this.settings();
    this.bindEvents();
    this.renderModalTemplate();
  }

  settings() {
    this.type = '';
    this.logo = '';
    this.name = '';
    this.content = '';
    this.url = '';
    this.date = '';
    this.stage = '';
    this.companyTwitter = '';
    this.trigger = '[data-ref="company-item"]';
    this.modalId = 'company-modal';
  }

  bindEvents() {
    this.onTriggerHover = this.onTriggerHover.bind(this);
    this.onClick = this.onClick.bind(this);
    this.el.addEventListener('mouseover', this.onTriggerHover);
    this.el.addEventListener('click', this.onClick);
  }

  renderModalTemplate() {
    const template = `<div class="modal modal--slide" id="${this.modalId}" aria-hidden="true">
        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
            <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="team-member-title">
                <button class="modal__close" aria-label="Close modal" data-micromodal-close></button>

                <div class="modal__content" id="company-content"></div>
            </div>
        </div>
    </div>`;

    document.body.insertAdjacentHTML('beforeend', template);

    // Save reference for scroll positioning later
    this.modal = document.getElementById(this.modalId);
    this.overlay = this.modal.querySelector('.modal__overlay');
    this.modalContent = document.getElementById('company-content');
    this.close = this.modal.querySelector('.modal__close');
  }

  onTriggerHover(e) {
    if (!e.target.closest(this.trigger)) return;

    this.loadData(e.target.closest(this.trigger));
  }

  loadData(element) {
    this.type = element.dataset.type;
    this.logo = element.dataset.logo;
    this.name = element.dataset.name;
    this.date = element.dataset.date;

    if (element.dataset.stage) {
      this.stage = element.dataset.stage;
    }

    if (element.dataset.content) {
      this.content = element.dataset.content;
    }
    if (element.dataset.url) {
      this.url = element.dataset.url;
    }
    if (element.dataset.twitter) {
      this.companyTwitter = element.dataset.twitter;
    }

    this.close.style.display = 'inline-flex';
    this.render();
  }

  onClick(e) {
    if (!e.target.closest(this.trigger)) return;

    e.preventDefault();
    this.showModal();
  }

  showModal() {
    MicroModal.show(this.modalId, {
      awaitCloseAnimation: true,
      disableScroll: true,
      onClose: () => {
        this.unloadData();
      },
      onShow: () => {
        this.overlay.scrollTop = 0;
      },
    });
  }

  unloadData() {
    this.type = '';
    this.logo = '';
    this.name = '';
    this.content = '';
    this.url = '';
    this.date = '';
    this.stage = '';
    this.companyTwitter = '';

    this.modalContent.innerHTML = '';
    this.close.style.display = 'none';
  }

  render() {
    let template = `
    <div class="modal__header">
        <img class="modal__logo" src="${this.logo}">
        <h3 class="type-headline-s">${this.name}</h3>
    </div>`;

    template += '<div class="modal__text">';

    if (this.content) {
      template += `<div class="text type-body mb-space-fixed-2">${this.content}</div>`;
    }
    if (this.url || this.companyTwitter) {
      template += '<div class="modal__tags mb-space-fixed-2">';
    }

    if (this.url) {
      template += `<a class="modal__link" href="${this.url}" title="Website" target="_blank" rel="noopener noreferrer">Website</a>`;
    }

    if (this.companyTwitter) {
      template += `<a class="modal__link" href="${this.companyTwitter}" title="Twitter" target="_blank" rel="noopener noreferrer">Twitter</a>`;
    }

    if (this.url || this.companyTwitter) {
      template += '</div>';
    }

    if ((this.date && (this.date !== 'Invalid DateTime')) || ((this.stage || this.type))) {
      template += '<ul class="modal__tags">';
    }
    if (this.date && (this.date !== 'Invalid DateTime')) {
      template += `<li class="tag">${this.date}</li>`;
    }
    if (this.stage) {
      template += `<li class="tag">${this.stage}</li>`;
    }
    if (this.type) {
      template += `<li class="tag tag--capitelize">${this.type}</li>`;
    }
    if ((this.date && (this.date !== 'Invalid DateTime')) || ((this.stage || this.type))) {
      template += '</ul>';
    }

    template += '</div>';

    this.modalContent.innerHTML = template;
  }

  unmount() {
    this.el.removeEventListener('mouseover', this.onTriggerHover);
    this.el.removeEventListener('click', this.onClick);
  }
}
